<template>
  <div>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <img :src="imgDomain + scope.row.img" class="carousel-img" />
          </template>
        </el-table-column>
        <el-table-column label="跳转地址" align="center">
          <template slot-scope="scope">
            {{ scope.row.url }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="opration-item" @click="editServiceClick(scope.row)"
                >编辑</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getServiceList } from "@/api/service-manage";
import { mapState } from "vuex";

export default {
  name: "slideimgmanage",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      handle_row: {},
    };
  },
  computed: {
    ...mapState(["imgDomain"]),
  },
  mounted() {
    this._getServiceList();
  },
  components: {},
  methods: {
    async _getServiceList() {
      const { data, status } = await getServiceList();
      console.log(data, "服务数据");
      if (status !== 200) return;
      this.tableData = data.data.data;
    },
    editServiceClick(row) {
      this.$router.push({
        path: "/service-handle",
        query: {
          uuid: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
}
.table-wrap {
  margin-bottom: 40px;
  .carousel-img {
    width: 100%;
    max-height: 300px;
  }
}
.operation-wrap {
  display: flex;
  justify-content: space-around;
  color: @color-text;
  .opration-item {
    cursor: pointer;
  }
}
.dialog-body-wrap {
  text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
</style>
